/* eslint-disable @typescript-eslint/naming-convention */
import classNames from 'classnames';
import React, { useMemo } from 'react';
import styles from "./ribbon.module.css";
/**
 * The color of the `Ribbon`.
 *
 * @remarks `yellow-200` is deprecated
 */

/**
 * ### The Ribbon component.
 */
export const Ribbon = _ref => {
  let {
    color = 'gray-150',
    size = 'small',
    children,
    className,
    ...props
  } = _ref;

  const getRibbonTextColor = color => {
    const [colorName, colorValue] = color.split('-');
    const ribbonColor = Number(colorValue) <= 300 ? `var(--color-${colorName}-500)` : 'var(--color-white)';
    return ribbonColor;
  };

  const textClass = size === 'small' ? 'ud-heading-xs' : 'ud-heading-sm';
  const sizeClass = size === 'large' ? styles.large : '';
  const ribbonBackgroundColor = `var(--color-${color})`;
  const ribbonColor = useMemo(() => getRibbonTextColor(color), [color]);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    style: {
      '--ribbon-background-color': ribbonBackgroundColor,
      '--ribbon-color': ribbonColor
    },
    className: classNames(styles.ribbon, styles[color], textClass, sizeClass, className)
  }, props), children);
};
/**
 * ### Badge
 *
 * @deprecated Use `Ribbon` from `@udemy/react-messaging-components` instead.
 */

export const Badge = _ref2 => {
  let {
    children,
    className,
    ...props
  } = _ref2;
  return /*#__PURE__*/React.createElement(Ribbon, Object.assign({
    className: classNames('ud-badge', className)
  }, props), children);
};
//# sourceMappingURL=ribbon.react-component.js.map